export const locales = ["sr", "en", "hu"] as const;
export const defaultLocale = "sr" as const;

export type Locale = (typeof locales)[number];

export const localeNames: Record<Locale, string> = {
  sr: "Srpski",
  en: "English",
  hu: "Magyar",
};

export const localeFlags: Record<Locale, string> = {
  sr: "🇷🇸",
  en: "🇬🇧",
  hu: "🇭🇺",
};


